import { gql } from "@apollo/client";
import {
  client,
  GET_DJ_COURSE_DETAILS_QUERY,
  GET_PRECONTRACT_COURSE_DETAILS_QUERY,
} from "api";
import { CustomEmailData, DocumentType } from "interfaces";

interface MutationParams {
  params: {
    emailsData: CustomEmailData[];
    documentType: DocumentType;
  };
}

interface RefetchParams {
  params: {
    sencenet: string;
    documentType: DocumentType;
  };
}

interface MutationResult {
  sendCustomReminders: boolean;
}

export const sendCustomReminders = async (
  params: MutationParams["params"],
  refetchParams: RefetchParams["params"],
): Promise<boolean> => {
  if (
    !params.emailsData ||
    params.emailsData.length === 0 ||
    !params.documentType
  )
    return false;
  const response = await client.mutate<MutationResult, MutationParams>({
    mutation: gql`
      mutation SendCustomReminders($params: SendCustomRemindersParams!) {
        sendCustomReminders(params: $params)
      }
    `,
    variables: {
      params,
    },
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query:
          params.documentType === DocumentType.PRECONTRACT
            ? GET_PRECONTRACT_COURSE_DETAILS_QUERY(params.documentType)
            : GET_DJ_COURSE_DETAILS_QUERY(params.documentType, refetchParams.sencenet),
        variables: {
          params: refetchParams,
        },
      },
    ],
  });
  return !!response.data?.sendCustomReminders;
};
